import { deprecated } from 'typesafe-actions';

import { ConfigActionType } from './actionTypes';

const { createStandardAction } = deprecated;

export const setIsServer = createStandardAction(
  ConfigActionType.SET_IS_SERVER
)<boolean>();
